import {CommonModule} from '@angular/common';
import {Component, computed, inject, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterLink} from '@angular/router';
import {lastValueFrom} from 'rxjs';
import {injectQuery} from '@tanstack/angular-query-experimental';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';

interface SearchResult {
  url: string;
  title: string;
  snippet: string;
  rank: number;
  realTitle: string;
}

@Component({
  selector: 'app-search-v2',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './search-v2.component.html',
  styleUrl: './search-v2.component.scss',
})
export class SearchV2Component {
  private readonly http = inject(HttpClient);
  protected readonly searchText = signal('');
  protected readonly submittedQuery = signal('');

  protected readonly searchQuery = injectQuery(() => ({
    queryKey: ['site-search', this.submittedQuery()],
    enabled: this.submittedQuery().length >= 2,
    queryFn: () => {
      const params = new HttpParams().set('query', this.submittedQuery()).set('topK', '10');
      return lastValueFrom(this.http.get<SearchResult[]>(`${environment.assessorSiteUrl}/api/Search`, {params}));
    },
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  }));

  protected readonly results = computed(() => this.searchQuery.data() ?? []);

  protected submit(): void {
    this.submittedQuery.set(this.searchText().trim());
  }

  protected clear(): void {
    this.searchText.set('');
    this.submittedQuery.set('');
  }

  protected updateSearchText(value: string): void {
    this.searchText.set(value);
  }
}
